import PropTypes from 'prop-types'
import { useContext } from 'react'

// Context
import { ModalContext } from '@/context/ModalContext'

// Internal components
import Svg from '../Svg/Svg'

const SymbolCard = (props) => {
  const { title, description, icon, link, count, length } = props

  const createMarkup = (copy) => ({ __html: copy })

  const modalContext = useContext(ModalContext)

  const clickEvent = (link) => {
    if (link?.type === 'api') {
      modalContext.setStateClass('is-loading')
      modalContext.openModal(link)
    }
  }

  return (
    <div
      className={`SymbolCard${count < length - 2 ? ' has-border' : ''}${link ? ' is-linked' : ''}`}
      onClick={(e) => clickEvent(link)}
      modal-type={link?.type}
      modal-route={link?.route}
    >
      <div className="SymbolCard-figure">
        {icon && (
          <div className="SymbolCard-icon">
            <Svg modifiers={['SymbolCard-iconBackground']} id="icon-category-shield" />
            <Svg modifiers={['SymbolCard-iconSymbol']} id={icon.id} />
          </div>
        )}
      </div>
      {title && <h2 className="SymbolCard-title" dangerouslySetInnerHTML={createMarkup(title)}></h2>}
      {description && <p className="SymbolCard-description">{description}</p>}
      {link && link.label && (
        <span className="SymbolCard-label">
          {link.label}
          <Svg id="icon-chevron-right" modifiers={['SymbolCard-labelIcon']} />
        </span>
      )}
    </div>
  )
}

SymbolCard.propTypes = {
  data: PropTypes.array,
  modifiers: PropTypes.array,
  map: PropTypes.func,
  length: PropTypes.number,
  link: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.object,
  count: PropTypes.number
}

export default SymbolCard
